import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button, DropdownItem , DropdownMenu , Nav , NavItem, Dropdown , DropdownToggle} from 'reactstrap';
import * as actions from '../../actions/notificaciones';
import {api, request, API_URL} from '../../actions/_request';

import { Alert } from 'reactstrap';

class Alerta extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      visible: true
    };

    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss() {
    // this.setState({ visible: false });
    // console.log('eliminar')
    this.props.elimnar_notificacion(this.props.creacion);
  
  }

  

   componentDidMount() {
     // setTimeout(this.onDismiss() , 6000);

    setTimeout(() => {
    // console.log('eliminar')
    this.props.elimnar_notificacion(this.props.creacion);
    }, 3000);
     
    }

  render() {
    return (
      <Alert color={this.props.tipo} isOpen={this.state.visible} toggle={this.onDismiss}>
       {this.props.mensaje}
      </Alert>
    );
  }
}

function mapStateToProps(state, ownProps) {
    return {
       notificaciones : state.notificaciones,
    }
};

export default connect(mapStateToProps, actions)(Alerta)




// WEBPACK FOOTER //
// ./src/components/notificaciones/alerta.js